import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    constructor() {
    }

    public get(key: string): string {
        return sessionStorage.getItem(key);
    }

    public set(key: string, value: string) {
        sessionStorage.setItem(key, value);
    }

    public remove(key: string) {
        sessionStorage.removeItem(key);
    }
}
